import api from "./api";
import { BaseResponse } from "../types/responses.type";
import { CourierResponse } from "types/trip.types";

class CouriersService {
  static async getCouriers(): Promise<BaseResponse<CourierResponse[]>> {
    try {
      const response = await api.get("/courier");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch couriers",
      };
    }
  }

  static async getCourier(id: number): Promise<BaseResponse<CourierResponse>> {
    try {
      const response = await api.get(`/courier/${id}`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch courier",
      };
    }
  }
}

export default CouriersService;
